import React from 'react'
import axios from 'axios'
import DBConn from '~/Classes/siteVars.js'
import { connect } from 'react-redux';
import queryString from 'query-string';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import LandingPageTemplate from '../login/template'
@connect((store) => {
    return {
        user: store.user, siteMaster: store.siteMaster
    }
})

export default class VerifyDomain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tokenError: "",
            tokenInvalid: false
        }
    }

    componentDidMount() {
        const ourToken = this.props.match.params.token;

        const query = queryString.parse(this.props.location.search);
        var accountMasterId = query.am;

        var baseUrl = DBConn.getConnString()
        axios.put(baseUrl + '/verifyDomain/' + ourToken + '?am=' + accountMasterId).then(res => {
            if (res.data.Success) {
                this.setState({ tokenError: "", tokenInvalid: false })
            }
            else {
                this.setState({ tokenError: "This token was invalid or has expired", tokenInvalid: true })
            }
        }).catch(err => {
            this.setState({ tokenInvalid: true })
        })
    }

    render() {



        let headerText = <div className="mar-b16">Your domain has been verified</div>;
        let subheaderText = <>
            <div>Success! Your domain has been verified. </div>
            <div>You can now return to the previous tab to continue setup.</div>
        </>;
        let subsubheaderText = <Button text="Close this window" onClick={() => { window.close() }} className="button-primary mar-t32" style={{ width: "100%" }} />;

        if (this.state.tokenError) {
            headerText = <div className="mar-b16">Something went wrong</div>;
            subheaderText = <div>{this.state.tokenError}</div>;
            subsubheaderText = <Button text="Continue" onClick={() => { this.props.history.push('/') }} className="button-primary mar-t32" style={{ width: "100%" }} />;
        }

        return <LandingPageTemplate header={headerText} subheader={subheaderText} subsubheader={subsubheaderText}></LandingPageTemplate>

    };
};